// ── Tartalmi mezők segédfüggvényei ───────────────────────────────────────────
// A data/*.json fájlokban a kitöltetlen mezőket TODO_PLACEHOLDER jelöli. Ezek
// SOHA nem jelenhetnek meg a látogatónak: inkább hiányozzon egy sor, mint hogy
// helyőrző-szöveg kerüljön ki élesbe. Tiszta függvények → unit tesztelhetők a
// komponens (és a react-router) betöltése nélkül.

/** Kitöltött-e a mező (a TODO_… kezdetű helyőrző NEM az). */
export const isFilled = (v) => Boolean(v) && !String(v).startsWith('TODO_');

/** Monogram a hiányzó portré helyett: „Papp Norbert” → „PN”. */
export const initials = (name = '') =>
  String(name).trim().split(/\s+/).slice(0, 2).map((w) => w[0] || '').join('').toUpperCase();

/** Hány éve működik – az alapítás évéből SZÁMOLVA, nem kézzel írt szám.
 *  Így az „X éve” állítás nem avul el a következő évfordulón.
 *  Az alapítás évében (és hibás/hiányzó értéknél) `null` – nem írunk ki 0-t. */
export const yearsSince = (foundedYear, now = new Date()) => {
  const y = Number(foundedYear);
  if (!y || Number.isNaN(y)) return null;
  const diff = now.getFullYear() - y;
  return diff > 0 ? diff : null;
};

// ── Javított készülékek számlálója ───────────────────────────────────────────
// FIGYELEM – a havi növekmény NEM valós mért adat, hanem a bázisérték óta
// eltelt hónapokra képzett, determinisztikus becslés (a tulajdonos döntése).
// Amit ezért betartunk:
//   • a hónap a véletlen-mag → egy adott hónapban MINDEN látogató ugyanazt a
//     számot látja, és oldalfrissítéskor sem ugrál (különben azonnal látszana,
//     hogy generált),
//   • a kimenet mindig „+” jelzéssel megy ki (legalább ennyi),
//   • a bázist érdemes félévente a VALÓS számra frissíteni a data/founder.json
//     `repairedCounter.base` és `.since` mezőjében – a becslés így nem szalad el.

/** Determinisztikus 0..1 érték egy egész magból (nincs Math.random). */
const seededUnit = (seed) => {
  const x = Math.sin(seed * 12.9898) * 43758.5453;
  return x - Math.floor(x);
};

/** Egy naptári hónap növekménye a [min, max] tartományból, determinisztikusan. */
export const monthlyIncrement = (year, month, min = 10, max = 45) => {
  const span = Math.max(0, max - min);
  return min + Math.floor(seededUnit(year * 12 + month) * (span + 1));
};

/**
 * Javított készülékek becsült száma a bázis óta eltelt hónapokkal.
 * @param cfg  { base, since: 'YYYY-MM', minPerMonth, maxPerMonth }
 * @param now  a mai dátum (tesztelhetőség miatt injektálható)
 * @returns    egész szám, vagy null ha a config hiányos/hibás
 */
export const repairedCount = (cfg, now = new Date()) => {
  if (!cfg || typeof cfg.base !== 'number' || !cfg.since) return null;
  const m = /^(\d{4})-(\d{2})$/.exec(String(cfg.since));
  if (!m) return null;
  const min = typeof cfg.minPerMonth === 'number' ? cfg.minPerMonth : 10;
  const max = typeof cfg.maxPerMonth === 'number' ? cfg.maxPerMonth : 45;

  let year = Number(m[1]);
  let month = Number(m[2]);
  const nowYear = now.getFullYear();
  const nowMonth = now.getMonth() + 1;
  let total = cfg.base;

  // Biztonsági korlát: 600 hónap (50 év) – elavult `since` sem pöröghet végtelenbe.
  for (let i = 0; i < 600; i += 1) {
    if (year > nowYear || (year === nowYear && month >= nowMonth)) break;
    month += 1;
    if (month > 12) { month = 1; year += 1; }
    total += monthlyIncrement(year, month, min, max);
  }
  return total;
};
